import React from 'react'
import { createStyles, withStyles } from '@material-ui/core'

import image from './search-docs.svg'
import { flexBreakpoint } from '../../components/Info/styles'

const styles = (theme) => {
  return createStyles({
    image: {
      [theme.breakpoints.up(flexBreakpoint)]: {
        width: '24.5rem',
      },
    },
  })
}

const Image = ({ classes }) => {
  return <img src={image} alt="Tinkercodes logo" className={classes.image} />
}

export default withStyles(styles)(Image)
